<template>
    <div class="main-container" :class="{ 'show-container': showFilter }">
        <div v-if="loader.data" class="loading-container">
            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
        </div>

        <div v-else-if="!loader.data && filteredReports.length > 0" class="report-container">
            <report-card v-for="(report, index) in filteredReports" :key="index" :data="report" :index="index" />
        </div>

        <div v-else class="empty">
            Não há relatórios para exibir...
        </div>

        <download-csv-xlsx-modal />
        <generate-reports-modal />
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { reportsCategory } from '@/services/axios'
	import { storage } from '@/services/storage'

	import reportCard from '../components/report-card'
	import downloadCsvXlsxModal from '../components/download-csv-xlsx-modal'
	import generateReportsModal from '../components/generate-reports-modal'

	import axios from 'axios'

	const defaultLoader = () => ({
		data: false,
	})

	export default {
		name: 'ui-new-reports-list',
		components: {
			reportCard,
			uiLoadIndicator,
			downloadCsvXlsxModal,
			generateReportsModal
		},

		data() {
			return {
				reports: [],
				filteredReports: [],
				loader: { ...defaultLoader() },
				showFilter: false,
				file: ''
			}
		},

		mounted() {
			this.$root.$on('set-new-reports', (item, categoryFile) => {
				this.getReportsCategory(categoryFile)
			})

			this.$root.$on('new-reports', response => {
				this.reports = response
			})

			this.$root.$on('show-filters', response => {
				this.showFilter = response
			})

			this.$root.$on('close-filters', response => {
				this.showFilter = response
			})
		},

		beforeDestroy() {
			this.$root.$off('set-new-reports')
			this.$root.$off('new-reports')
			this.$root.$off('show-filters')
			this.$root.$off('close-filters')
		},

		methods: {
			/**
			 * Chama o arquivo .JSON do "file" de cada categoria separadamente de forma dinâmica!
			 */
			async getReportsCategory(categoryFile) {
      			if (this.loader.data) document.dispatchEvent(new CustomEvent('abortInPluginAxios'))
      			this.loader.data = true
      			storage.set('report_data', JSON.stringify({ categoryFile }))

				/**
                * Determina se a requisição será feita no Data Lake com base na instância da empresa.
                */
				const getStorage = JSON.parse(storage.get('api_config'))
      			const instance = getStorage.instance
      			const reportsCategoryInstance = await reportsCategory.defineVersionReports(instance)

				reportsCategoryInstance.getAllV2(`category-reports/?file=${categoryFile}`)
      				.then(response => {
      				    this.filteredReports = response.data
      				    this.loader.data = false
      				})
      				.catch(error => {
      				    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
      				    console.log(error)
      				    if (!axios.isCancel(error)) this.loader.data = false
      				})
   			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
